export default __webpack_public_path__ + "static/media/logo.57bf8e8a.png";